export default __webpack_public_path__ + "static/media/arrow-back.b6d6624c.svg";